import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import forwardVectorIcon from 'src/assets/img/common/forward_rounded_vector.png'
import BtnNext from 'src/assets/img/common/pink_forward_rounded_vector.png'

export const VoiceAlbumPagination = ({ totalPage, currPage, setCurrPage, theme = 'blue' }) => {
  const getPageNumbers = () => {
    if (totalPage <= 10) {
      return Array.from({ length: totalPage }, (_, i) => i + 1)
    }

    const pages = [1]
    let left = currPage - 2
    let right = currPage + 2
    if (currPage <= 3) {
      left = 2
      right = 5
    } else if (currPage >= totalPage - 2) {
      left = totalPage - 4
      right = totalPage - 1
    }
    if (left > 2) {
      pages.push('ellipsis-left')
    }
    for (let i = left; i <= right; i++) {
      if (i > 1 && i < totalPage) {
        pages.push(i)
      }
    }
    if (right < totalPage - 1) {
      pages.push('ellipsis-right')
    }
    pages.push(totalPage)

    return pages
  }

  const pages = getPageNumbers()
  return (
    <div className="flex items-center justify-center mt-2 space-x-2">
      <button
        onClick={() => currPage > 1 && setCurrPage(currPage - 1)}
        disabled={currPage === 1}
        className={clsx('w-5 h-6', {
          'cursor-pointer': currPage !== 1,
          'opacity-50': currPage === 1
        })}
      >
        <img
          className={clsx('w-full h-full transform rotate-180', {
            invisible: currPage === 1
          })}
          src={theme === 'blue' ? forwardVectorIcon : BtnNext}
          alt="Previous"
        />
      </button>

      <div className="flex items-center space-x-2">
        {pages.map((page, index) => {
          if (typeof page === 'string' && page.includes('ellipsis')) {
            return (
              <span key={`${page}-${index}`} className="px-2 text-candy-pink">
                …
              </span>
            )
          }
          return (
            <button
              key={page}
              onClick={() => setCurrPage(page)}
              className={clsx('px-2 py-1 rounded', {
                'bg-sky-blue text-white': theme === 'blue' && page === currPage,
                'bg-candy-pink text-white': theme !== 'blue' && page === currPage,
                'cursor-pointer hover:bg-gray-200 text-candy-pink': page !== currPage
              })}
            >
              {page}
            </button>
          )
        })}
      </div>

      <button
        onClick={() => currPage < totalPage && setCurrPage(currPage + 1)}
        disabled={currPage === totalPage}
        className={clsx('w-5 h-6', {
          'cursor-pointer': currPage !== totalPage,
          'opacity-50': currPage === totalPage
        })}
      >
        <img
          className={clsx('w-full h-full', {
            invisible: currPage === totalPage
          })}
          src={theme === 'blue' ? forwardVectorIcon : BtnNext}
          alt="Next"
        />
      </button>
    </div>
  )
}

VoiceAlbumPagination.propTypes = {
  totalPage: PropTypes.number,
  currPage: PropTypes.number,
  setCurrPage: PropTypes.func,
  theme: PropTypes.string
}
